import { callGetEvents, callSendEmailPostPack } from '../../api/expo.js'
import {
  triggerAlert,
  triggerErrorGeneric,
  isSuccessResponse,
} from '../util.js'

export async function dispatchSetEvents(context, data = null) {
  try {
    if (!data) {
      const response = await callGetEvents()
      if (response?.data?.events) {
        data = response.data.events
      }
    }

    context.commit('UPDATE_EVENTS', data)
  } catch {
    context.commit('CLEAR_EVENTS', [])
    triggerErrorGeneric()
  }
}

/**
 * Send post pack request email.
 *
 * @param {Object} context state context
 * @param {Object} payload post pack data
 *
 * @returns {Boolean} success/failure
 */
export async function dispatchSendEmailPostPack(context, payload = null) {
  try {
    const response = await callSendEmailPostPack(payload)

    triggerAlert(response)
    return isSuccessResponse(response)
  } catch {
    triggerErrorGeneric()
  }
}
